import React, { Component } from 'react';

import { getBlog, getAllBlogs } from '../data/serviceBlogs';
import BlogExplorer from './components/BlogExplorer/Explorer';
import Blog from './components/BlogProfile/Blog';

class Blogs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			blogs: [],
			currentImages:[],
			currentBlog: null,
			testLinks: [],
		}
		this.load = this.load.bind(this);
		this.loadBlogs = this.loadBlogs.bind(this);
	}
	componentDidMount() {
		this.loadBlogs();
	}
	async loadBlogs() {
		this.setState({
			blogs: await getAllBlogs().then(blogs => { return blogs; }),
		});
	}
	load(id) {
		//console.log("loading blog "+id);
		getBlog(id).then(data => {
			//console.log(data)
			this.setState({ currentBlog: data.result});
			//console.log(this.state);
			if (data.result.clientCodes.length === 0) {
				data.result["clientCodes"] = [];
			}
		}).then(() => {
			document.querySelectorAll("#blogs-profile-column .profile")[0].style.display = "block";
		})
	}
	render() {
		const { blogs, currentBlog } = this.state;
		const clients = this.props.clients;
		
		return (
			<div className="columns">
				<BlogExplorer
					blogs={blogs}
					load={this.load}
				/>
				<Blog
					currentBlog={currentBlog}
					clients={clients}
					load={this.load}
					loadAll={this.loadBlogs}
				/>
			</div>
		);
	}
}

export default Blogs;


// WEBPACK FOOTER //
// ./src/component_blog/Blogs.js